<div class="container">
    <h2>Institutional Account Related Memos</h2>
  <ul>
      <li>
          <a href="https://afr.fo.uiowa.edu/changes-institutional-accounts-may-2017" title="Changes in Institutional Accounts (May 2017) " target="_blank">
              Changes in Institutional Accounts (May 2017)
          </a>
      </li>
      <li>
          <a href="https://afr.fo.uiowa.edu/changes-institutional-accounts-july-2015" title="Changes in Institutional Accounts (July 2015)" target="_blank">
              Changes in Institutional Accounts (July 2015)
          </a>
      </li>
      <li>
          <a href="http://afr.fo.uiowa.edu/tuition-support-grad-students-notice-april-21-2015" title="Tuition Support for Grad Students Notice (April 21, 2015)" target="_blank">
              Tuition Support for Grad Students Notice (April 21, 2015)
          </a>
      </li>
      <li>
          <a href="https://afr.fo.uiowa.edu/new-institutional-accounts-track-it-equipment-services-april-1-2014" title="New Institutional Accounts to Track IT Equipment & Services (April 1, 2014)" target="_blank">
              New Institutional Accounts to Track IT Equipment & Services (April 1, 2014)
          </a>
      </li>
  </ul>
</div>